import { Box, Grid, Typography } from '@mui/material';
import type { deriveFormattedPolicyDetails } from '../../utils/endorsement-workflow.utils';
import {
  CoverageGridCell,
  DeltaGridCell,
  GlobalsHeaderCell,
  TypographyUppercase,
} from '../../components/CoverageSummaryResolver/CoverageSummary/CoverageGridCell';
import { Address } from './Address';

interface InsuredInformationSummaryProps {
  endorsementDetails: {
    companyName: string;
    address1: string;
    address2: string;
    city: string;
    zipCode: string;
  };
  policyDetails: ReturnType<typeof deriveFormattedPolicyDetails>;
}

export const InsuredInformationSummary = ({
  endorsementDetails,
  policyDetails,
}: InsuredInformationSummaryProps) => {
  const policyAddress = {
    companyName: policyDetails.companyName || '',
    address1: policyDetails.address1 || '',
    address2: policyDetails.address2 || '',
    city: policyDetails.city || '',
    zipCode: policyDetails.zipCode || '',
  };

  return (
    <Grid container>
      <InsuredInformationSummaryHeader />

      <DeltaGridCell item md={4} isDelta isOdd sx={{ padding: '1rem' }}>
        <TypographyUppercase variant="caption">
          Company Name:
        </TypographyUppercase>
      </DeltaGridCell>

      <CoverageGridCell item md={4} isOdd>
        <Typography variant="caption">{policyDetails.companyName}</Typography>
      </CoverageGridCell>

      <CoverageGridCell item md={4} isOdd>
        <Typography variant="caption">
          {endorsementDetails.companyName}
        </Typography>
      </CoverageGridCell>

      <DeltaGridCell item md={4} isDelta isOdd={false} sx={{ padding: '1rem' }}>
        <TypographyUppercase variant="caption">Address:</TypographyUppercase>
      </DeltaGridCell>

      <CoverageGridCell item md={4} isOdd={false}>
        <Box>
          <Typography variant="caption">
            <Address {...policyAddress} state={policyDetails.state as string} />
          </Typography>
        </Box>
      </CoverageGridCell>

      <CoverageGridCell item md={4} isOdd={false}>
        <Box display="block">
          <Typography variant="caption">
            <Address
              {...endorsementDetails}
              state={policyDetails.state as string}
            />
          </Typography>
        </Box>
      </CoverageGridCell>
    </Grid>
  );
};

export const InsuredInformationSummaryHeader = () => {
  return (
    <>
      <GlobalsHeaderCell
        item
        sm={4}
        sx={{
          padding: '1rem',
        }}
      >
        <TypographyUppercase variant="subtitle2" color="primary">
          Insured Info
        </TypographyUppercase>
      </GlobalsHeaderCell>
      <GlobalsHeaderCell item sm={4}>
        <TypographyUppercase variant="subtitle2" color="primary">
          Policy
        </TypographyUppercase>
      </GlobalsHeaderCell>
      <GlobalsHeaderCell item sm={4}>
        <TypographyUppercase variant="subtitle2" color="primary">
          Endorsement
        </TypographyUppercase>
      </GlobalsHeaderCell>
    </>
  );
};
